export default ({
  data: { value }
}) => {
  return {
    editorIsBlockBeingDragged: value
  }; 
};
